import DescriptionOutlined from "@mui/icons-material/DescriptionOutlined";
import UploadOutlined from "@mui/icons-material/UploadOutlined";
import ReceiptLongOutlined from "@mui/icons-material/ReceiptLongOutlined";
import MenuBookOutlined from "@mui/icons-material/MenuBookOutlined";
import Inventory2Outlined from "@mui/icons-material/Inventory2Outlined";
import MailOutlined from "@mui/icons-material/MailOutlined";

// Resolves the icon name the API's document_types[].icon returns to its MUI
// icon component - components can't travel over JSON, so this lookup table
// is infrastructure, not a stand-in for the DocumentType's own data.
export const ICONS_BY_NAME = {
  DescriptionOutlined,
  UploadOutlined,
  ReceiptLongOutlined,
  MenuBookOutlined,
  Inventory2Outlined,
  MailOutlined,
};
